<template>
  <el-container class="equipment-config-container">
    <el-header height="60px" class="header-container">
      <el-button type="primary" size="small" @click="goBack" class="back-button">
        返回
      </el-button>
    </el-header>
    <el-main class="main-container">
      <div class="page-title">
        {{ orgName }}设备数据专项分析
      </div>
      <el-row :gutter="24" class="top-charts">
        <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
          <el-card class="chart-card" shadow="hover" :body-style="{ padding: '20px' }">
            <template #header>
              <div class="chart-title">
                对接设备/品目数量
              </div>
            </template>
            <div ref="chartRef1" class="chart-container" style="height: 280px;"></div>
          </el-card>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
          <el-card class="chart-card" shadow="hover" :body-style="{ padding: '20px' }">
            <template #header>
              <div class="chart-title">
                品牌分布
              </div>
            </template>
            <div ref="chartRef2" class="chart-container" style="height: 280px;"></div>
          </el-card>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
          <el-card class="chart-card" shadow="hover" :body-style="{ padding: '20px' }">
            <template #header>
              <div class="chart-title">
                资产/合同价格
              </div>
            </template>
            <div ref="chartRef3" class="chart-container" style="height: 280px;"></div>
          </el-card>
        </el-col>
      </el-row>
      <el-card class="chart-card mt-24" shadow="hover" :body-style="{ padding: '20px' }">
        <template #header>
          <div class="chart-title">
            MRI设备1个月内每日使用有效扫描时长分布（分钟）
          </div>
        </template>
        <div ref="chartRef4" class="chart-container" style="height: 400px;"></div>
      </el-card>
      <el-card class="chart-card mt-24" shadow="hover" :body-style="{ padding: '20px' }">
        <template #header>
          <div class="chart-title">
            CT类设备1个月内每日使用有效扫描时长分布分析（分钟）
          </div>
        </template>
        <div ref="chartRef5" class="chart-container" style="height: 400px;"></div>
      </el-card>
    </el-main>
  </el-container>
</template>

<script>
import * as echarts from 'echarts'
export default {
  name: 'SpecialDetail',
  data() {
    return {
      orgCode: this.$route.query.orgCode,
      orgName: this.$route.query.orgName,
      charts: {}
    }
  },
  mounted() {
    this.initCharts()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    Object.values(this.charts).forEach(chart => {
      if (chart) {
        chart.dispose()
      }
    })
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    initCharts() {
      this.charts.chart1 = echarts.init(this.$refs.chartRef1)
      this.charts.chart2 = echarts.init(this.$refs.chartRef2)
      this.charts.chart3 = echarts.init(this.$refs.chartRef3)
      this.charts.chart4 = echarts.init(this.$refs.chartRef4)
      this.charts.chart5 = echarts.init(this.$refs.chartRef5)
      this.updateCharts()
    },
    updateCharts() {
      this.updateChart1()
      this.updateChart2()
      this.updateChart3()
      this.updateChart4()
      this.updateChart5()
    },
    updateChart1() {
      const option = {
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c}'
        },
        legend: {
          orient: 'vertical',
          left: 'left',
          data: ['MRI', 'CT', 'PET/CT', 'PET/MR']
        },
        series: [
          {
            name: '设备数量',
            type: 'pie',
            radius: '60%',
            center: ['50%', '50%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 4,
              borderColor: '#fff',
              borderWidth: 2,
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.2)'
            },
            label: {
              show: true,
              position: 'outside',
              formatter: '{b}: {c}',
              fontSize: '12',
              color: '#333'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '14',
                fontWeight: 'bold'
              },
              itemStyle: {
                shadowBlur: 20,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.4)'
              }
            },
            labelLine: {
              show: true,
              length: 10,
              length2: 10
            },
            data: [
              { value: 16, name: 'MRI', itemStyle: { color: '#69c0ff' } },
              { value: 13, name: 'CT', itemStyle: { color: '#b37feb' } },
              { value: 3, name: 'PET/CT', itemStyle: { color: '#73d13d' } },
              { value: 1, name: 'PET/MR', itemStyle: { color: '#ff7a45' } }
            ]
          }
        ]
      }
      this.charts.chart1.setOption(option)
    },
    updateChart2() {
      const option = {
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)'
        },
        legend: {
          orient: 'vertical',
          left: 'left',
          data: ['西门子', '联影', 'GE']
        },
        series: [
          {
            name: '品牌分布',
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 2
            },
            label: {
              show: true,
              position: 'outside',
              formatter: '{b}: {c} ({d}%)',
              fontSize: '12',
              color: '#333'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '14',
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: true,
              length: 10,
              length2: 10
            },
            data: [
              { value: 73, name: '西门子', itemStyle: { color: '#69c0ff' } },
              { value: 18, name: '联影', itemStyle: { color: '#73d13d' } },
              { value: 9, name: 'GE', itemStyle: { color: '#ff7a45' } }
            ]
          }
        ]
      }
      this.charts.chart2.setOption(option)
    },
    updateChart3() {
      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          data: ['资产/合同价格']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: ['CT', 'MRI', 'PET/CT']
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value}'
          }
        },
        series: [
          {
            name: '资产/合同价格',
            type: 'bar',
            data: [
              { value: 96454236, itemStyle: { color: '#69c0ff' } },
              { value: 169090400, itemStyle: { color: '#69c0ff' } },
              { value: 37986000, itemStyle: { color: '#69c0ff' } }
            ],
            label: {
              show: true,
              position: 'top',
              formatter: '{c}',
              fontSize: '12',
              color: '#333'
            }
          }
        ]
      }
      this.charts.chart3.setOption(option)
    },
    updateChart4() {
      const dates = []
      for (let i = 2; i <= 28; i++) {
        dates.push(`2026-2-${i}`)
      }
      const option = {
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['3221001003', '3221001004', '3221401008']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: dates,
          axisLabel: {
            rotate: 45
          }
        },
        yAxis: {
          type: 'value',
          name: '分钟'
        },
        series: [
          {
            name: '3221001003',
            type: 'line',
            data: [150, 180, 200, 190, 210, 230, 250, 220, 240, 260, 280, 270, 290, 310, 300, 280, 320, 340, 330, 350, 370, 360, 380, 400, 390, 410, 400],
            symbol: 'circle',
            symbolSize: 8,
            itemStyle: { color: '#ffd666' },
            label: {
              show: true,
              position: 'top',
              formatter: '{c}',
              fontSize: '10',
              color: '#ffd666'
            }
          },
          {
            name: '3221001004',
            type: 'line',
            data: [200, 220, 240, 230, 250, 270, 290, 280, 300, 320, 340, 330, 350, 370, 360, 380, 400, 420, 410, 430, 450, 440, 460, 480, 470, 490, 480],
            symbol: 'circle',
            symbolSize: 8,
            itemStyle: { color: '#73d13d' },
            label: {
              show: true,
              position: 'top',
              formatter: '{c}',
              fontSize: '10',
              color: '#73d13d'
            }
          },
          {
            name: '3221401008',
            type: 'line',
            data: [100, 120, 130, 110, 140, 160, 150, 170, 180, 160, 190, 200, 180, 210, 220, 200, 230, 240, 220, 250, 260, 240, 270, 280, 260, 290, 270],
            symbol: 'circle',
            symbolSize: 8,
            itemStyle: { color: '#69c0ff' },
            label: {
              show: true,
              position: 'top',
              formatter: '{c}',
              fontSize: '10',
              color: '#69c0ff'
            }
          }
        ]
      }
      this.charts.chart4.setOption(option)
    },
    updateChart5() {
      const dates = []
      for (let i = 2; i <= 28; i++) {
        dates.push(`2026-2-${i}`)
      }
      const option = {
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['3221001003', '3221001004', '3221401008']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: dates,
          axisLabel: {
            rotate: 45
          }
        },
        yAxis: {
          type: 'value',
          name: '分钟',
          max: 800
        },
        series: [
          {
            name: '3221001003',
            type: 'line',
            data: [200, 250, 300, 280, 320, 350, 380, 360, 390, 420, 450, 430, 460, 490, 470, 450, 480, 500, 490, 510, 530, 520, 540, 560, 550, 570, 560],
            symbol: 'circle',
            symbolSize: 8,
            itemStyle: { color: '#ffd666' },
            label: {
              show: true,
              position: 'top',
              formatter: '{c}',
              fontSize: '10',
              color: '#ffd666'
            }
          },
          {
            name: '3221001004',
            type: 'line',
            data: [400, 450, 480, 460, 500, 530, 560, 540, 570, 600, 630, 610, 640, 670, 650, 630, 660, 690, 680, 700, 720, 710, 730, 750, 740, 760, 740],
            symbol: 'circle',
            symbolSize: 8,
            itemStyle: { color: '#73d13d' },
            label: {
              show: true,
              position: 'top',
              formatter: '{c}',
              fontSize: '10',
              color: '#73d13d'
            }
          },
          {
            name: '3221401008',
            type: 'line',
            data: [50, 80, 100, 90, 110, 130, 120, 140, 150, 130, 160, 170, 150, 180, 190, 170, 200, 210, 190, 220, 230, 210, 240, 250, 230, 260, 240],
            symbol: 'circle',
            symbolSize: 8,
            itemStyle: { color: '#69c0ff' },
            label: {
              show: true,
              position: 'top',
              formatter: '{c}',
              fontSize: '10',
              color: '#69c0ff'
            }
          }
        ]
      }
      this.charts.chart5.setOption(option)
    },
    handleResize() {
      Object.values(this.charts).forEach(chart => {
        if (chart) {
          chart.resize()
        }
      })
    },
    goBack() {
      this.$router.push('/dataView/special')
    }
  }
}
</script>

<style lang="scss">
.equipment-config-container {
  min-height: 100vh;
  background-color: #f5f7fa;
}

.header-container {
  padding: 0 20px;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
}

.back-button {
  margin-right: auto;
}

.main-container {
  padding: 30px 20px;
}

.page-title {
  font-size: 28px;
  font-weight: bold;
  color: #333;
  margin-bottom: 36px;
  text-align: center;
  color: #000;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.top-charts {
  margin-bottom: 24px;
}

.chart-card {
  transition: all 0.3s ease;
  border-radius: 12px;
  overflow: hidden;
  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.12);
  }
}

.chart-title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  text-align: center;
  margin: 0;
}

.chart-container {
  width: 100%;
}

.mt-24 {
  margin-top: 24px;
}

// 响应式调整
@media screen and (max-width: 768px) {
  .main-container {
    padding: 20px 16px;
  }
  
  .page-title {
    font-size: 24px;
    margin-bottom: 24px;
  }
  
  .chart-container {
    height: 250px !important;
  }
}
</style>